import { QrConsumosUsuariosComponent } from '@pages/reportes/qr-leidos/qr-consumos-usuarios/qr-consumos-usuarios.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DropdownMenuComponent } from './dropdown/dropdown-menu/dropdown-menu.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { ModalComponent } from './modal/modal.component';
import { CopyClipboardComponent } from './copy-clipboard/copy-clipboard.component';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { CuentasRelacionadasComponent } from './cuentas-relacionadas/cuentas-relacionadas.component';
import { SharedPipesModule } from '@/pipes/shared-pipes.module';
import { DynamicTableListComponent } from './dynamic-table-list/dynamic-table-list.component';
import { CollapseComponent } from './collapse/collapse.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalDetallesComponent } from '@pages/reportes/qr-leidos/modal-detalles/modal-detalles.component';
import { IconActionButtonComponent } from './icon-action-button/icon-action-button.component';
import { InputComponent } from './input/input.component';
import { InputWithSuffixComponent } from './input-with-suffix/input-with-suffix.component';
import { AlertComponent } from './alert/alert.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ToggleComponent } from './toggle/toggle.component';
import { FavoriteMenuComponent } from './favorite-menu/favorite-menu.component';
import { ImageCropEditorComponent } from './image-crop-editor/image-crop-editor.component';


@NgModule({
  declarations: [
    ButtonComponent,
    CheckboxComponent,
    DropdownMenuComponent,
    DropdownComponent,
    MenuItemComponent,
    ModalComponent,
    CopyClipboardComponent,
    CollapseComponent,
    DynamicTableComponent,
    CuentasRelacionadasComponent,
    DynamicTableListComponent,
    ModalDetallesComponent,
    QrConsumosUsuariosComponent,
    IconActionButtonComponent,
    InputComponent,
    InputWithSuffixComponent,
    AlertComponent,
    PaginatorComponent,
    ToggleComponent,
    FavoriteMenuComponent,
    ImageCropEditorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    SharedPipesModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    ButtonComponent,
    CheckboxComponent,
    DropdownMenuComponent,
    DropdownComponent,
    MenuItemComponent,
    ModalComponent,
    CopyClipboardComponent,
    CollapseComponent,
    DynamicTableComponent,
    DynamicTableListComponent,
    CuentasRelacionadasComponent,
    ModalDetallesComponent,
    QrConsumosUsuariosComponent,
    IconActionButtonComponent,
    InputComponent,
    InputWithSuffixComponent,
    AlertComponent,
    PaginatorComponent,
    ToggleComponent,
    FavoriteMenuComponent,
    ImageCropEditorComponent,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule
  ]
})
export class SharedComponentsModule { }
